const ACCESS_KEY =
  process.env.REACT_APP_WEB3FORMS_ACCESS_KEY || "96dca6f9-97f3-482f-884e-0dc1606e3816";
const WEB3FORMS_ENDPOINT = "https://api.web3forms.com/submit";

export const SUCCESS_MESSAGE =
  "Thank you. Your enquiry has been sent successfully and the EDT team will be in touch.";
export const ERROR_MESSAGE =
  "Your enquiry could not be sent. Please try again or contact us on WhatsApp.";

// Submits a form to Web3Forms. `fields` is a flat map of field label -> value.
// `botcheck` is the honeypot value (should be empty for real users).
export async function sendContactForm({ subject, from_name, fields = {}, botcheck = "" }) {
  const body = {
    access_key: ACCESS_KEY,
    subject,
    from_name: from_name || "EDT Solutions Website",
    botcheck,
    ...fields,
  };

  let res;
  let data;
  try {
    res = await fetch(WEB3FORMS_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
    data = await res.json();
  } catch (e) {
    console.error("Web3Forms submission failed:", e);
    throw new Error(ERROR_MESSAGE);
  }

  if (!res.ok || !data || data.success !== true) {
    throw new Error(ERROR_MESSAGE);
  }
  return data;
}
